import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useExportTextingReportMutation = ({
	onError,
	onSuccess,
	impersonationContext,
	includeAll,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
	includeAll?: boolean;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			includeAll: includeAllOverride,
			...request
		}: Api.TextMessagesExportRequest & { includeAll?: boolean }) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'reports/texting/export',
					// A per-call `includeAll` (e.g. a date-scoped admin export) takes precedence over the hook-level default.
					queryParams: { includeAll: includeAllOverride ?? includeAll },
					impersonationContext,
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
